import { replaceUrlPlaceholders } from "react-utils";
import axiosCoralie from "../axios-setup";
import { addQueryParams } from "../utils/urlUtils";

const CONF = window?.confPub;
const MESSAGES_ACCUEIL_ROUTES = CONF?.ROUTES?.MESSAGES_ACCUEIL

export const getMessagesAccueil = async (params) => {

    // eslint-disable-next-line no-useless-catch
    try {

        const queryParams = addQueryParams(params)
        const resp = await axiosCoralie.get(MESSAGES_ACCUEIL_ROUTES?.GET_MESSAGES + queryParams)

        const messagesAccueil = resp?.data?.messagesAccueil

        if (resp?.status === 204) {

            // return { messagesAccueil: [] }
            return []

        } else if (messagesAccueil?.length > 0) {

            return messagesAccueil

        } else {

            throw new Error("Aucune contribution trouvée")
        }

    } catch (err) {
        throw err;
    }
}

export const addMessageAccueil = async (dataToSend) => {

    // eslint-disable-next-line no-useless-catch
    try {

        const resp = await axiosCoralie.post(MESSAGES_ACCUEIL_ROUTES?.ADD_MESSAGE, dataToSend)
        return resp?.data

    } catch (err) {

        throw err;
    }
}

export const updateMessage = async (id, dataToSend) => {
    // eslint-disable-next-line no-useless-catch
    try {

        const urlWithId = replaceUrlPlaceholders(MESSAGES_ACCUEIL_ROUTES?.UPDATE_MESSAGE, { id: id })
        const resp = await axiosCoralie.put(urlWithId, dataToSend)
        return resp?.data

    } catch (err) {

        throw err;
    }
}

export const deleteMessage = async (id) => {
    // eslint-disable-next-line no-useless-catch
    try {

        const urlWithId = replaceUrlPlaceholders(MESSAGES_ACCUEIL_ROUTES?.DELETE_MESSAGE, { id: id })
        const resp = await axiosCoralie.delete(urlWithId)

        return resp?.data

    } catch (err) {

        throw err;
    }
}